<template>
<div class="chapter">
<div class="inner_page">
<p class="block_" id="id_Toc39728741"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1"><span class="text_">About the Author</span></h1>
<p class="block_"> </p>
<p class="block_2"> </p>
<p class="block_3"> </p>
<p class="block_4"><span class="text_1">Stacey Fischer was born 1990 in Melbourne, Australia. Some of her lyrical/vocal work may be found through the indie-rock band, Astrohym. The tale within her first novel however, seemed to her, far too elaborate to be held by song. Whether her words are sung or written, every note is inspired by the meet-cute of heart-felt experience, prolific embellishment, and sometimes, even the truth. </span><span class="text_2">Second Reality</span><span class="text_1"> was the first ever novel authored by Stacey. The words therein began as her 14-year-old self-made wishes for those things she did not have. Now, her only wish is to share the story with you.</span></p>
<p class="block_5"><span class="text_3"><br class="calibre1" id="calibre_pb_0"/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?579fb13e